const LocalStorageKeys = {
	AUTH: 'AUTH',
	DeviceId: 'DeviceId',
}

export default LocalStorageKeys
